import React, { Component } from 'react';
import Toolbar from '../components/Toolbar/Toolbar';
import PageProgress from '../components/PageProgress/pageProgress';
import HeaderCarousel from '../components/HeaderCarousel/HeaderCarousel';
import TypeController from '../components/TypeController/TypeController';
import MainSwiper from '../components/MainSwiper/MainSwiper';
import * as actions from '../store/actions/index';
import { connect } from 'react-redux';
import Footer from '../components/Footer/Footer';
import MainSearchForm from '../components/MainSearchForm/MainSearchForm';
import './HomePage.scss';

class HomePage extends Component {
  componentWillMount() {
    this.props.onFetchTrending();
    this.props.onFetchMoviesGenresID();
    this.props.onFetchTvGenresID();
    this.handleMovies();
    this.handleTvs();
  }

  handleMovies = () => {
    this.props.onFetchUpcoming();
    this.props.onFetchNowPlaying();
    this.props.onFetchPopular();
    this.props.onFetchTopRated();
  };

  handleTvs = () => {
    this.props.onFetchOnTheAir();
    this.props.onFetchPopularTv();
    this.props.onFetchAringToday();
    this.props.onFetchTopRatedTv();
  };

  showMovies = () => {
    this.props.onChangeTypeMovie();
  };

  showTV = () => {
    this.props.onChangeTypeTv();
  };

  render() {
    const {
      type,
      nowPlaying,
      genresMoviesId,
      upcoming,
      topRated,
      popular,
      onAir,
      popularTv,
      aringToday,
      topRatedTv,
      genresTvId,
      trending
    } = this.props;
    let swipers;

    if (this.props.type === 'movie') {
      swipers = (
        <>
          <MainSwiper
            title={'Now Playing'}
            type={type}
            sources={nowPlaying}
            genres={genresMoviesId}
          />
          <MainSwiper
            title={'Upcoming'}
            type={type}
            sources={upcoming}
            genres={genresMoviesId}
          />
          <MainSwiper
            title={'Top Rated'}
            type={type}
            sources={topRated}
            genres={genresMoviesId}
          />
          <MainSwiper
            title={'Popular'}
            type={type}
            sources={popular}
            genres={genresMoviesId}
          />
        </>
      );
    } else if (type === 'tv') {
      swipers = (
        <>
          <MainSwiper
            title={'On The Air'}
            type={type}
            sources={onAir}
            genres={genresTvId}
          />
          <MainSwiper
            title={'Popular Today'}
            type={type}
            sources={popularTv}
            genres={genresTvId}
          />
          <MainSwiper
            title={'Airing Today'}
            type={type}
            sources={aringToday}
            genres={genresTvId}
          />
          <MainSwiper
            title={'Top Rated'}
            type={type}
            sources={topRatedTv}
            genres={genresTvId}
          />
        </>
      );
    }

    return (
      <div className="home-container">
        <PageProgress />
        <Toolbar>
          <MainSearchForm />
        </Toolbar>
        <HeaderCarousel headSliderSources={trending} type={type} />
        <TypeController
          showMovies={this.showMovies}
          showTVs={this.showTV}
          showActive={type}
        />
        <div className="main-content">{swipers}</div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  genresMoviesId: state.genresIdReducer.genresMoviesId,
  genresTvId: state.genresIdReducer.genresTvId,

  upcoming: state.movieReducer.upcoming,
  trending: state.movieReducer.trending,
  popular: state.movieReducer.popular,
  nowPlaying: state.movieReducer.nowPlaying,
  topRated: state.movieReducer.topRated,

  aringToday: state.tvReducer.aringToday,
  onAir: state.tvReducer.onAir,
  popularTv: state.tvReducer.popularTv,
  topRatedTv: state.tvReducer.topRatedTv,

  type: state.changeTypeReducer.type
});

const mapDispatchToProps = dispatch => ({
  onFetchMoviesGenresID: () => dispatch(actions.fetchMoviesGenresID()),
  onFetchTvGenresID: () => dispatch(actions.fetchTvGenresID()),
  // movies
  onFetchTrending: () => dispatch(actions.fetchTrending()),
  onFetchUpcoming: () => dispatch(actions.fetchUpcoming()),
  onFetchPopular: () => dispatch(actions.fetchPopular()),
  onFetchNowPlaying: () => dispatch(actions.fetchNowPlaying()),
  onFetchTopRated: () => dispatch(actions.fetchTopRated()),
  //tv
  onFetchOnTheAir: () => dispatch(actions.fetchOnTheAir()),
  onFetchPopularTv: () => dispatch(actions.fetchPopularTv()),
  onFetchAringToday: () => dispatch(actions.fetchAringToday()),
  onFetchTopRatedTv: () => dispatch(actions.fetchTopRatedTv()),
  // change type
  onChangeTypeMovie: () => dispatch(actions.changeTypeMovie()),
  onChangeTypeTv: () => dispatch(actions.changeTypeTv())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage);
